import '/home/runner/work/addon-visual-tests/addon-visual-tests/node_modules/storybook-addon-designs/register.js';